import { GoogleButton } from '@arcadiapower/shrike';
import styled from 'styled-components';

export const GoogleSignUpButton = styled(GoogleButton)`
  p {
    width: auto;
  }
`;
